/* unplugin-vue-components disabled */import script from "./AppTimer.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppTimer.vue?vue&type=script&lang=ts&setup=true"

import "./AppTimer.vue?vue&type=style&index=0&id=0869d728&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0869d728"]])

export default __exports__